import store from 'store'
import { formatPrice } from 'utils/general'
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'

export default el => new Vue({
  el,
  store,
  data () {
    return {
      noteExpanded: false,
      message: ''
    }
  },
  mounted () {
    this.message = this.cart.note

    if (this.cartItems.length) {
      this.fetchDeliveryData()
    }
  },
  computed: {
    ...mapState('global', [
      'cart'
    ]),
    ...mapState('cart', [
      'loading'
    ]),
    cartItems () {
      this.toggleEmptyClass()
      return (this.cart.items || [])
    },
    visibleCartItems () {
      return this.cartItems.filter(item => __GLOBAL__.engravingItem.id !== item.id)
    },
    cartQuantity () {
      let qty = 0
      const items = this.visibleCartItems
      for (let i = 0; i < items.length; i++) {
        qty = qty + items[i].quantity
      }
      return qty
    },
    isEmpty () {
      return this.visibleCartItems.length === 0
    },
    cartTitleMeta () {
      if (this.cartQuantity === 0) {
        return '(0)'
      }

      return `- ${this.cartQuantity} ${this.cartQuantity === 1 ? 'item' : 'items'}`
    },
    cartTotal () {
      return this.priceFormat(this.cart.total_price)
    }
  },
  methods: {
    ...mapActions('cart', [
      'fetchDeliveryData'
    ]),
    toggleEmptyClass () {
      const cartWrapper = document.querySelector('.template--cart')
      if (cartWrapper) {
        if (this.cart.items.length <= 0) {
          cartWrapper.classList.add('cart-is-empty')
        } else {
          cartWrapper.classList.remove('cart-is-empty')
        }
      }
    },
    priceFormat (price) {
      return formatPrice(price)
        .replace(/\bPLN\b/g, 'zl')
        .replace(/z\u0142/g, 'zl')
    },
    toggleNote () {
      this.noteExpanded = !this.noteExpanded
    },
    checkoutCart () {
      this.$refs.cartForm.submit()
    }
  }
})
